var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 87,
    viewBox: "0 0 19 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4354 20.1875V7.58802C18.5473 5.75293 17.5626 3.33598 17.5626 1.61278C17.5626 -0.110417 15.5485 0.00147833 15.5485 0.00147833H9.68515H8.7676H2.90426C2.90426 0.00147833 0.890126 -0.110417 0.890126 1.61278C0.890126 3.33598 -0.0945565 5.75293 0.0173395 7.58802V20.1651C0.0173395 20.1651 -0.318351 22.694 1.96433 22.694H8.74523C9.30471 22.694 9.66277 22.694 9.66277 22.694H16.4437C18.7487 22.694 18.3907 20.1651 18.3907 20.1651L18.4354 20.1875Z",
    fill: "#9E8959"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1014_4052",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 22,
    width: 18,
    height: 65
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7212 22.6494H0.757812V86.6315H17.7212V22.6494Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1014_4052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.61243 16.2934H8.85154C5.15599 16.2934 2.16016 19.2893 2.16016 22.9848V78.3509C2.16016 82.0465 5.15599 85.0423 8.85154 85.0423H9.61243C13.308 85.0423 16.3038 82.0465 16.3038 78.3509V22.9848C16.3038 19.2893 13.308 16.2934 9.61243 16.2934Z",
    fill: "white",
    stroke: "#555555",
    strokeWidth: 1.55556,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23828 3.51514V19.0239",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40234 5.41699V19.0235",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0469 5.41699V19.0235",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6061 31.6265H5.29297V74.2541H15.6061",
    stroke: "#9E8959",
    strokeWidth: 1.37509
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 44.9745V45.3701H15.8023V44.9745H11.0195Z",
    fill: "#004137"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 44.5293V44.727H15.8023V44.5293H11.0195Z",
    fill: "#004137"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 43.8862V44.084H15.8023V43.8862H11.0195Z",
    fill: "#004137"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 42.8237V43.0215H15.8023V42.8237H11.0195Z",
    fill: "#004137"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 41.9824V42.1802H15.8023V41.9824H11.0195Z",
    fill: "#004137"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9883 40.9198V41.3154H15.771V40.9198H10.9883Z",
    fill: "#004137"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 40.4501V40.6479H15.8023V40.4502L11.0195 40.4501Z",
    fill: "#004137"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9883 39.2139V39.832H15.771V39.2139H10.9883Z",
    fill: "#004137"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 38.1264V38.3242H15.8023V38.1264H11.0195Z",
    fill: "#004137"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 38.5702V38.9658H15.8023V38.5702H11.0195Z",
    fill: "#004137"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 37.2852V37.9033H15.8023V37.2852H11.0195Z",
    fill: "#004137"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 36.2226V36.6182H15.8023V36.2226H11.0195Z",
    fill: "#004137"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 35.7519V35.9497H15.8023V35.7519H11.0195Z",
    fill: "#004137"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 54.6005V54.9961H15.8023V54.6005H11.0195Z",
    fill: "#004137"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 54.1552V54.353H15.8023V54.1552H11.0195Z",
    fill: "#004137"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 53.5126V53.7104H15.8023V53.5127L11.0195 53.5126Z",
    fill: "#004137"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 52.4492V52.647H15.8023V52.4492H11.0195Z",
    fill: "#004137"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 51.6088V51.8066H15.8023V51.6088H11.0195Z",
    fill: "#004137"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9883 50.5453V50.9409H15.771V50.5453H10.9883Z",
    fill: "#004137"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 50.0766V50.2744H15.8023V50.0766H11.0195Z",
    fill: "#004137"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9883 48.8404V49.4585H15.771V48.8404H10.9883Z",
    fill: "#004137"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 47.7529V47.9507H15.8023V47.7529H11.0195Z",
    fill: "#004137"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 48.1967V48.5923H15.8023V48.1967H11.0195Z",
    fill: "#004137"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 46.9112V47.5293H15.8023V46.9112H11.0195Z",
    fill: "#004137"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 45.8485V46.2441H15.8023V45.8485H11.0195Z",
    fill: "#004137"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 45.3784V45.5762H15.8023V45.3784H11.0195Z",
    fill: "#004137"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 64.226V64.6216H15.8023V64.226H11.0195Z",
    fill: "#004137"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 63.7807V63.9785H15.8023V63.7807H11.0195Z",
    fill: "#004137"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 63.1381V63.3359H15.8023V63.1381H11.0195Z",
    fill: "#004137"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 62.0751V62.2729H15.8023V62.0752L11.0195 62.0751Z",
    fill: "#004137"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 61.2338V61.4316H15.8023V61.2338H11.0195Z",
    fill: "#004137"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9883 60.1713V60.5669H15.771V60.1713H10.9883Z",
    fill: "#004137"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 59.7021V59.8999H15.8023V59.7021H11.0195Z",
    fill: "#004137"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9883 58.4659V59.084H15.771V58.4659H10.9883Z",
    fill: "#004137"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 57.3779V57.5757H15.8023V57.3779H11.0195Z",
    fill: "#004137"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 57.8222V58.2178H15.8023V57.8222H11.0195Z",
    fill: "#004137"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 56.5367V57.1548H15.8023V56.5367H11.0195Z",
    fill: "#004137"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 55.474V55.8696H15.8023V55.474H11.0195Z",
    fill: "#004137"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0195 55.0039V55.2016H15.8023V55.0039H11.0195Z",
    fill: "#004137"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9883 67.622V68.0176H15.771V67.622H10.9883Z",
    fill: "#004137"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9883 67.1762V67.374H15.771V67.1762H10.9883Z",
    fill: "#004137"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9883 66.5336V66.7314H15.771V66.5336H10.9883Z",
    fill: "#004137"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9883 65.4707V65.6684H15.771V65.4707H10.9883Z",
    fill: "#004137"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9883 64.6293V64.8271H15.771V64.6293H10.9883Z",
    fill: "#004137"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M8.21559 47.4905C8.21559 47.4905 8.24376 47.4342 8.27193 47.4342H8.73669C8.73669 47.4342 8.79303 47.4623 8.79303 47.4905V49.1946C8.79303 49.1946 8.76486 49.265 8.72261 49.265C7.38465 49.251 6.55371 48.6454 6.55371 47.3778C6.55371 46.1666 7.38465 45.3779 8.6381 45.3779C9.89156 45.3779 10.7225 46.2089 10.7225 47.4623C10.7225 48.0961 10.5112 48.5608 10.1732 48.9129C10.145 48.9411 10.1169 48.927 10.1028 48.9129L9.65213 48.5468C9.65213 48.5468 9.63805 48.5186 9.63805 48.5045C9.63805 48.4904 9.63805 48.4763 9.65213 48.4623C9.80705 48.2933 10.0324 47.913 10.0324 47.4482C10.0324 46.6173 9.48313 46.068 8.65219 46.068C7.82125 46.068 7.27198 46.5891 7.27198 47.3778C7.27198 48.0257 7.59591 48.4341 8.22968 48.5468V47.4764L8.21559 47.4905Z",
    fill: "#9E8959"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7225 51.7856C10.7225 53.039 9.89156 53.8559 8.6381 53.8559C7.38465 53.8559 6.55371 53.039 6.55371 51.7856C6.55371 50.5321 7.38465 49.7012 8.6381 49.7012C9.89156 49.7012 10.7225 50.5321 10.7225 51.7856ZM7.2579 51.7856C7.2579 52.6024 7.80716 53.1658 8.6381 53.1658C9.46904 53.1658 10.0183 52.6165 10.0183 51.7856C10.0183 50.9546 9.46905 50.4053 8.6381 50.4053C7.80716 50.4053 7.2579 50.9546 7.2579 51.7856Z",
    fill: "#9E8959"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24119 56.533C7.24119 56.533 7.22711 56.5893 7.18486 56.5893H6.66376C6.66376 56.5893 6.60742 56.5612 6.60742 56.533V54.5754C6.60742 54.5754 6.63559 54.519 6.66376 54.519H10.6072C10.6072 54.519 10.6636 54.5472 10.6636 54.5754V55.1669C10.6636 55.1669 10.6354 55.2232 10.6072 55.2232H7.24119V56.533Z",
    fill: "#9E8959"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60742 57.236C6.60742 57.236 6.63559 57.1797 6.66376 57.1797H10.6072C10.6072 57.1797 10.6636 57.2078 10.6636 57.236V58.4331C10.6636 59.6725 9.87485 60.5034 8.63548 60.5034C7.39611 60.5034 6.60742 59.6725 6.60742 58.4331V57.236ZM10.0157 57.8839H7.28344V58.4331C7.28344 59.2641 7.81863 59.8133 8.64957 59.8133C9.48051 59.8133 10.0157 59.2641 10.0157 58.4331V57.8839Z",
    fill: "#9E8959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.6343a912c70dcad8fbaae13060e43b4a.svg";
export { ForwardRef as ReactComponent };